export interface WhiteLabelSettings {
    /**
     * Branded Services Publish State
     */
    isEnabled: boolean;
}
